<template>
    <div class="shadows-wrapper">
        <div class="scroll-container scrollbar-hide" :style="{ height }" ref="scrollContainer"
            @scroll.passive="toggleShadow">
            <slot />
            <span class="shadow-bottom" :class="{ 'is-active': shadow.bottom }" />
        </div>
    </div>
</template>


<script>
function newResizeObserver(callback) {
    // Skip this feature for browsers which don't support ResizeObserver.
    // https://caniuse.com/#search=resizeobserver
    if (typeof ResizeObserver === "undefined") return;

    return new ResizeObserver((e) => e.map(callback));
}

export default {
    name: "ScrollShadow",
    data() {
        return {
            height: undefined,
            shadow: {
                bottom: false,
            },
        };
    },
    mounted() {
        // Check if shadows are necessary after the element is resized.
        const scrollContainerObserver = newResizeObserver(this.toggleShadow);
        if (scrollContainerObserver) {
            scrollContainerObserver.observe(this.$refs.scrollContainer);
            // Cleanup when the component is destroyed.
            this.$once("hook:destroyed", () => scrollContainerObserver.disconnect());
        }

        // Recalculate the container dimensions when the wrapper is resized.
        const wrapObserver = newResizeObserver(this.calcDimensions);
        if (wrapObserver) {
            wrapObserver.observe(this.$el);
            // Cleanup when the component is destroyed.
            this.$once("hook:destroyed", () => wrapObserver.disconnect());
        }
    },
    methods: {
        async calcDimensions() {
            // Reset dimensions for correctly recalculating parent dimensions.
            this.height = undefined;
            await this.$nextTick();

            this.height = `${this.$el.clientHeight}px`;
        },
        // Check if shadows are needed.
        toggleShadow() {
            const hasVerticalScrollbar =
                this.$refs.scrollContainer.clientHeight <
                this.$refs.scrollContainer.scrollHeight;

            const scrolledFromTop =
                this.$refs.scrollContainer.offsetHeight +
                this.$refs.scrollContainer.scrollTop;

            const scrolledToBottom = scrolledFromTop >= this.$refs.scrollContainer.scrollHeight;

            this.shadow.bottom = hasVerticalScrollbar && !scrolledToBottom;
        },
    },
};
</script>

<style lang="scss">
.shadows-wrapper {
    overflow: hidden;
    position: relative;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100 - 130px);
    scroll-behavior: smooth;
}

.scroll-container {
    overflow: auto;
}

.shadow-bottom {
    position: absolute;
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;
    right: 0;
    left: 0;
    bottom: 0;
    transform: rotate(180deg);
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    height: 32px;
    background-image: linear-gradient(to top,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 95%);
}

.is-active {
    opacity: 1;
}
</style>

<!-- Src: https://codesandbox.io/s/scrolling-shadows-with-vuejs-r6l5i?from-embed=&file=/src/components/ScrollShadow.vue:375-462 -->